module.exports = __webpack_public_path__ + "static/media/1.77cf5231.jpg";